import React from "react";
import {
  GridContainer,
  GridItem,
  DataCard,
  DataCardHeader,
  DataCardTitle,
  DataCardContent,
  DataItem,
  DataLabel,
  DataValue,
  AmountValue,
  ReportHeader,
  ReportHeaderTitle,
} from "./PeriodicAcquirerReport.styles";
import { AccountBalance, AttachMoney, Receipt } from "@mui/icons-material";

const PeriodicAcquirerReportBaseData = (props) => {
  const { acquirerID, acquirerName, consolidatedData } = props;

  const formatNumber = (value) => {
    if (typeof value === "string") {
      const num = parseFloat(value);
      return isNaN(num)
        ? value
        : num.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4,
          });
    }
    return value?.toLocaleString("en-US") || "0";
  };

  const isPositiveAmount = (value) => {
    const num = parseFloat(value);
    return !isNaN(num) && num >= 0;
  };

  return (
    <GridContainer>
      <GridItem xs={12}>
        <ReportHeader>
          <ReportHeaderTitle>Acquirer ISO Report Summary</ReportHeaderTitle>
        </ReportHeader>
      </GridItem>

      <GridItem xs={12} padding="15px">
        <DataCard>
          <DataCardHeader>
            <AccountBalance color="primary" />
            <DataCardTitle>Acquirer Information</DataCardTitle>
          </DataCardHeader>
          <DataCardContent>
            <DataItem>
              <DataLabel>Acquirer ID</DataLabel>
              <DataValue>{acquirerID || "N/A"}</DataValue>
            </DataItem>
            <DataItem>
              <DataLabel>Acquirer Name</DataLabel>
              <DataValue>{acquirerName || "N/A"}</DataValue>
            </DataItem>
          </DataCardContent>
        </DataCard>
      </GridItem>

      <GridItem xs={12} md={6} padding="15px">
        <DataCard>
          <DataCardHeader>
            <Receipt color="primary" />
            <DataCardTitle>Transaction Summary</DataCardTitle>
          </DataCardHeader>
          <DataCardContent>
            <DataItem>
              <DataLabel>Transaction Count</DataLabel>
              <DataValue>{consolidatedData?.transactionsCount || 0}</DataValue>
            </DataItem>
            <DataItem>
              <DataLabel>Amount</DataLabel>
              <DataValue>
                ${formatNumber(consolidatedData?.transactionsAmount || "0")}
              </DataValue>
            </DataItem>
          </DataCardContent>
        </DataCard>
      </GridItem>

      <GridItem xs={12} md={6} padding="15px">
        <DataCard>
          <DataCardHeader>
            <AttachMoney color="primary" />
            <DataCardTitle>Summary</DataCardTitle>
          </DataCardHeader>
          <DataCardContent>
            <DataItem>
              <DataLabel>Settlement</DataLabel>
              <AmountValue
                positive={isPositiveAmount(consolidatedData?.amountDue)}
              >
                ${formatNumber(consolidatedData?.amountDue || "0")}
              </AmountValue>
            </DataItem>
            <DataItem>
              <DataLabel>Processing Fee</DataLabel>
              <DataValue>
                ${formatNumber(consolidatedData?.txProcessing || "0")}
              </DataValue>
            </DataItem>
            <DataItem>
              <DataLabel>MDR Fee</DataLabel>
              <DataValue>
                ${formatNumber(consolidatedData?.txMDR || "0")}
              </DataValue>
            </DataItem>
          </DataCardContent>
        </DataCard>
      </GridItem>
    </GridContainer>
  );
};

export default PeriodicAcquirerReportBaseData;
